export default {
  useUrl: '//cmstool.youku.com/cms/player/userinfo/user_info?specialTest=test', // 用户信息获取接口回调
  loginSDK: '//g.alicdn.com/static-es6/login/public/load.js' // 登录组件地址回调
}
